import React from "react";
import NumberUnitInput from "../../input/number-unit-input";

const NumberUnit1Widget = ({ widget, onValueUpdate }) => {
  const handleValueUpdate = (value, unit, max, min) => {
    if (min !== null && value < min) {
      return;
    }
    if (max !== null && value > max) {
      return;
    }
    const updatedWidget = {
      ...widget,
      value: value.toString() + unit,
      unit,
      max,
      min,
    };
    onValueUpdate(updatedWidget);
  };

  return (
    <div className="flex items-center h-full w-full">
      {widget && (
        <NumberUnitInput
          valueSpec={widget}
          onChange={handleValueUpdate}
          onError={() => {}}
        />
      )}
    </div>
  );
};

export default NumberUnit1Widget;
